import { render, staticRenderFns } from "./AdvisorData.vue?vue&type=template&id=3dacee89&"
import script from "./AdvisorData.vue?vue&type=script&lang=js&"
export * from "./AdvisorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports